/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EmployeeAssistance } from '../models/EmployeeAssistance';
import type { EmployeeAssistanceListResponse } from '../models/EmployeeAssistanceListResponse';
import type { EmployeeAssistanceStatus } from '../models/EmployeeAssistanceStatus';
import type { EmployeeAssistanceVisibility } from '../models/EmployeeAssistanceVisibility';
import type { EmployeeCreateBodyParams } from '../models/EmployeeCreateBodyParams';
import type { EmployeeCreateWorkspaceBodyParams } from '../models/EmployeeCreateWorkspaceBodyParams';
import type { EmployeeListByWorkspaceBodyParams } from '../models/EmployeeListByWorkspaceBodyParams';
import type { EmployeeListResponse } from '../models/EmployeeListResponse';
import type { EmployeeUpdateBodyParams } from '../models/EmployeeUpdateBodyParams';
import type { EmployeeWorkspace } from '../models/EmployeeWorkspace';
import type { EmployeeWorkspaceType } from '../models/EmployeeWorkspaceType';
import type { TCEmployeeCreateResponse } from '../models/TCEmployeeCreateResponse';
import type { TCEmployeeExecutionListResponse } from '../models/TCEmployeeExecutionListResponse';
import type { TCEmployeeStepExecutionListResponse } from '../models/TCEmployeeStepExecutionListResponse';
import type { TCEmployeeUpdateResponse } from '../models/TCEmployeeUpdateResponse';
import type { TCEmployeeVersionGetResponse } from '../models/TCEmployeeVersionGetResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AutomationsEmployeesService {
    /**
     * Create a workspace association for an employee version
     * @param employeeId
     * @param version
     * @param requestBody
     * @returns EmployeeWorkspace Ok
     * @throws ApiError
     */
    public static createWorkspace(
        employeeId: string,
        version: any,
        requestBody: EmployeeCreateWorkspaceBodyParams,
    ): CancelablePromise<EmployeeWorkspace> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/automations/employees/{employeeId}/versions/{version}/workspaces',
            path: {
                'employeeId': employeeId,
                'version': version,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * List workspaces associated with an employee version
     * @param employeeId
     * @param version
     * @returns EmployeeWorkspace Ok
     * @throws ApiError
     */
    public static listWorkspaces(
        employeeId: string,
        version: any,
    ): CancelablePromise<Array<EmployeeWorkspace>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/automations/employees/{employeeId}/versions/{version}/workspaces',
            path: {
                'employeeId': employeeId,
                'version': version,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * List employee workspaces by workspace key
     * @param workspaceType
     * @param requestBody
     * @returns EmployeeWorkspace Ok
     * @throws ApiError
     */
    public static listEmployeesByWorkspace(
        workspaceType: EmployeeWorkspaceType,
        requestBody: EmployeeListByWorkspaceBodyParams,
    ): CancelablePromise<Array<EmployeeWorkspace>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/automations/employees/workspaces/{workspaceType}/employees',
            path: {
                'workspaceType': workspaceType,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Delete a workspace association for an employee version
     * @param employeeId
     * @param version
     * @param workspaceType
     * @param workspaceId
     * @returns EmployeeWorkspace Ok
     * @throws ApiError
     */
    public static deleteWorkspace(
        employeeId: string,
        version: any,
        workspaceType: EmployeeWorkspaceType,
        workspaceId: string,
    ): CancelablePromise<EmployeeWorkspace> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/automations/employees/{employeeId}/versions/{version}/workspaces/{workspaceType}/{workspaceId}',
            path: {
                'employeeId': employeeId,
                'version': version,
                'workspaceType': workspaceType,
                'workspaceId': workspaceId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Lists tenant-wide contexts where an AI Agent needs assistance.
     * @param limit
     * @param pageToken
     * @param status Lifecycle state to list; defaults to open at the service boundary.
     * @param employeeId Optional AI Agent filter.
     * @param category Optional blocker or advisory category filter.
     * @param conversationId Optional CRM conversation filter.
     * @param visibility Optional visibility boundary; omitted to list every authorized audience.
     * @param from Inclusive ISO lower bound over assistance occurrence time.
     * @param to Inclusive ISO upper bound over assistance occurrence time.
     * @returns EmployeeAssistanceListResponse The tenant's matching assistance records.
     * @throws ApiError
     */
    public static listAssistances(
        limit?: number,
        pageToken?: string,
        status?: EmployeeAssistanceStatus,
        employeeId?: string,
        category?: any,
        conversationId?: number,
        visibility?: EmployeeAssistanceVisibility,
        from?: string,
        to?: string,
    ): CancelablePromise<EmployeeAssistanceListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/automations/employees/assistances',
            query: {
                'limit': limit,
                'pageToken': pageToken,
                'status': status,
                'employeeId': employeeId,
                'category': category,
                'conversationId': conversationId,
                'visibility': visibility,
                'from': from,
                'to': to,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Dismisses one visible assistance record.
     * @param assistanceId
     * @returns EmployeeAssistance Ok
     * @throws ApiError
     */
    public static resolveAssistance(
        assistanceId: string,
    ): CancelablePromise<EmployeeAssistance> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/automations/employees/assistances/{assistanceId}/resolve',
            path: {
                'assistanceId': assistanceId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
            },
        });
    }
    /**
     * List executions for a specific employee version within a date range
     * @param employeeId
     * @param limit
     * @param pageToken
     * @param version
     * @param from
     * @param to
     * @returns TCEmployeeExecutionListResponse Ok
     * @throws ApiError
     */
    public static listExecutions(
        employeeId: string,
        limit?: number,
        pageToken?: string,
        version?: any,
        from?: string,
        to?: string,
    ): CancelablePromise<TCEmployeeExecutionListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/automations/employees/{employeeId}/executions',
            path: {
                'employeeId': employeeId,
            },
            query: {
                'limit': limit,
                'pageToken': pageToken,
                'version': version,
                'from': from,
                'to': to,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * List all step executions for a specific execution, including workflow executions
     * @param executionId
     * @returns TCEmployeeStepExecutionListResponse Ok
     * @throws ApiError
     */
    public static listStepExecutions(
        executionId: string,
    ): CancelablePromise<TCEmployeeStepExecutionListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/automations/employees/executions/{executionId}/steps',
            path: {
                'executionId': executionId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
            },
        });
    }
    /**
     * List all employees for the tenant
     * @param limit
     * @param pageToken
     * @returns EmployeeListResponse Ok
     * @throws ApiError
     */
    public static list(
        limit?: number,
        pageToken?: string,
    ): CancelablePromise<EmployeeListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/automations/employees',
            query: {
                'limit': limit,
                'pageToken': pageToken,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Create a new employee
     * @param requestBody
     * @returns TCEmployeeCreateResponse Ok
     * @throws ApiError
     */
    public static create(
        requestBody: EmployeeCreateBodyParams,
    ): CancelablePromise<TCEmployeeCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/automations/employees',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Update an existing employee
     * @param employeeId
     * @param requestBody
     * @returns TCEmployeeUpdateResponse Ok
     * @throws ApiError
     */
    public static update(
        employeeId: string,
        requestBody: EmployeeUpdateBodyParams,
    ): CancelablePromise<TCEmployeeUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/automations/employees/{employeeId}',
            path: {
                'employeeId': employeeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
            },
        });
    }
    /**
     * Delete an employee.
     *
     * Note: until the Integrations/Automations client exposes an employee delete endpoint,
     * this only deactivates the linked system user in the backend.
     * @param employeeId
     * @returns void
     * @throws ApiError
     */
    public static delete(
        employeeId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/automations/employees/{employeeId}',
            path: {
                'employeeId': employeeId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Get an employee version by ID
     * @param employeeId
     * @param version
     * @returns TCEmployeeVersionGetResponse Ok
     * @throws ApiError
     */
    public static getVersion(
        employeeId: string,
        version: any,
    ): CancelablePromise<TCEmployeeVersionGetResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/automations/employees/{employeeId}/versions/{version}',
            path: {
                'employeeId': employeeId,
                'version': version,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
